'use client'

import { createClient } from '@/lib/supabase/client'
import { useEffect, useState } from 'react'
import Link from 'next/link'

export function PartnersMarquee() {
    const [partners, setPartners] = useState<any[]>([])
    const supabase = createClient()

    useEffect(() => {
        const fetchPartners = async () => {
            const { data } = await supabase
                .from('partners')
                .select('*')
                .order('created_at', { ascending: false })

            if (data && data.length > 0) {
                setPartners(data)
            }
        }
        fetchPartners()
    }, [])

    if (partners.length === 0) return null

    // Duplicate list for infinite scroll effect
    const marqueePartners = [...partners, ...partners, ...partners, ...partners]

    return (
        <div className="w-full bg-[#0a0a0a] border-t border-white/5 py-8 overflow-hidden relative">
            <div className="container mx-auto px-4 mb-4">
                <h3 className="text-center text-gray-500 uppercase text-xs font-bold tracking-[0.2em]">Nos Partenaires</h3>
            </div>

            <div className="flex w-full overflow-hidden select-none">
                <div className="flex animate-marquee whitespace-nowrap items-center">
                    {marqueePartners.map((partner, index) => (
                        <div key={`${partner.id}-${index}`} className="mx-6 md:mx-10 shrink-0">
                            <div className="bg-white p-2 rounded-lg h-16 md:h-20 w-32 md:w-40 flex items-center justify-center shadow-lg border border-white/10 transition-transform hover:scale-105">
                                {partner.website_url ? (
                                    <a href={partner.website_url} target="_blank" rel="noreferrer" title={partner.name} className="w-full h-full flex items-center justify-center">
                                        <img
                                            src={partner.logo_url}
                                            alt={partner.name}
                                            className="max-h-full max-w-full object-contain"
                                        />
                                    </a>
                                ) : (
                                    <div className="w-full h-full flex items-center justify-center">
                                        <img
                                            src={partner.logo_url}
                                            alt={partner.name}
                                            title={partner.name}
                                            className="max-h-full max-w-full object-contain"
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Fades for smooth edges */}
            <div className="absolute top-0 left-0 w-24 h-full bg-gradient-to-r from-[#0a0a0a] to-transparent pointer-events-none z-10" />
            <div className="absolute top-0 right-0 w-24 h-full bg-gradient-to-l from-[#0a0a0a] to-transparent pointer-events-none z-10" />

            <style jsx>{`
                .animate-marquee {
                    animation: marquee 40s linear infinite;
                }
                @keyframes marquee {
                    0% { transform: translateX(0); }
                    100% { transform: translateX(-50%); } 
                }
            `}</style>
        </div>
    )
}
